import { render, staticRenderFns } from "./RetailerMyAccount.vue?vue&type=template&id=c8749bd0&lang=pug"
import script from "./RetailerMyAccount.vue?vue&type=script&lang=js"
export * from "./RetailerMyAccount.vue?vue&type=script&lang=js"
import style0 from "./RetailerMyAccount.vue?vue&type=style&index=0&id=c8749bd0&prod&lang=sass"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports